@if (authService.isLoggedIn()) {
<div class="avatar-menu">
  @if(authService.userPhotoUrl()) {
  <img [matMenuTriggerFor]="userMenu" [src]="authService.userPhotoUrl()" referrerpolicy="no-referrer" alt="Gebruikersprofiel" />
  } @else {
  <div [matMenuTriggerFor]="userMenu" class="initials">{{ authService.userInitials() }}</div>
  }
  <mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="logout()">
      <span>{{ t.afmelden }}</span>
    </button>
  </mat-menu>
</div>
}
